import Constants from 'expo-constants';

/**
 * Returns whether app is running in Expo Go client.
 * Can be useful for conditional native modules' integration.
 */
export function checkIfInExpoGoClient() {
  return Constants.appOwnership === 'expo';
}

/**
 * Returns a boolean indicating whether the app is configured with modern Expo Updates
 *
 * There are two types of manifest objects that can be exported from `expo-constants`:
 *
 * - `manifest`: Classic manifest for Expo apps using classic updates. Returns `null` when manifest2 is non-null.
 * - `manifest2`: New manifest for Expo apps using modern Expo Updates. Returns `null` when manifest is non-null.
 *
 * @see {@link https://docs.expo.dev/versions/latest/sdk/constants/ Expo Constants}
 */
export function checkIfUsingModernExpoUpdatesConfig() {
  return Boolean(Constants.manifest2);
}

/**
 * Returns a boolean indicating whether the app is being developed locally (Expo Go, dev client, etc.)
 */
export function checkIfInLocalDevelopmentMode() {
  const { manifest, manifest2 } = Constants;

  const isUsingModernExpoUpdatesConfig = checkIfUsingModernExpoUpdatesConfig();

  if (isUsingModernExpoUpdatesConfig) {
    return Boolean(manifest2?.extra?.expoGo?.packagerOpts?.dev);
  }

  return Boolean(manifest?.packagerOpts?.dev);
}

export function getLocalDevelopmentHost() {
  const { manifest, manifest2 } = Constants;

  const isUsingModernExpoUpdatesConfig = checkIfUsingModernExpoUpdatesConfig();

  const host =
    (isUsingModernExpoUpdatesConfig
      ? manifest2?.extra?.expoGo?.debuggerHost
      : manifest?.debuggerHost) ?? '';

  // extract host without port
  return host.split(':')[0];
}

/**
 * Returns the current application version from the Expo app config
 */
export function getAppVersion() {
  const { manifest: classicManifest, manifest2: modernManifest } = Constants;
  const isUsingModernExpoUpdatesConfig = checkIfUsingModernExpoUpdatesConfig();

  return isUsingModernExpoUpdatesConfig
    ? modernManifest?.extra?.expoClient?.version
    : classicManifest?.version;
}
